import DesktopScroll from "../desktop/NavbarScroll";
import MobileScroll from "../mobile/NavbarScroll";
import MediaQueries from "../../utils/MediaQueries";

export default function initScroll(isSleekBarOpened) {
    let scrollTimer,
        scrollY,
        lastScrollY = $(window).scrollTop(),

        // MOBILE
        $topBar = $(".mobile-top-bar"),
        $bottomBar = $(".mobile-bottom-bar"),
        $shareButton = $(".share"),

        // DESKTOP
        $menu = $(".menu"),
        stickyMenuClass = "menu--sticky",
        $userNav = $(".user-nav"),
        $userInfo = $(".user-info"),
        $brand = $(".brand"),
        isMobile, isTablet;

    function updateMediaQueries() {
        isMobile = MediaQueries.isMobile();
        isTablet = MediaQueries.isTablet();
    }

    function handleScroll() {
        scrollY = $(window).scrollTop();

        if (isMobile || isTablet) {
            MobileScroll.handleMobileScroll(scrollY, lastScrollY, $topBar, $bottomBar, $shareButton);
        } else {
            DesktopScroll.handleDesktopScroll(scrollY, lastScrollY, $menu, $userNav, $userInfo, $brand, isSleekBarOpened);
        }
        lastScrollY = scrollY;
    }

    // If page is already scrolled at load
    // make it sticky

    if(lastScrollY > 100) {
      $menu.addClass(stickyMenuClass);
    }

    $(window).scroll(function () {
        cancelAnimationFrame(scrollTimer);
        scrollTimer = requestAnimationFrame(handleScroll);
    });

    $(window).resize(function () {
        // TODO RCH : maybe try debounce instead of requestAnimationFrame
        requestAnimationFrame(updateMediaQueries);
    });

    updateMediaQueries();
}



// WEBPACK FOOTER //
// ./js/navbar/commons/NavbarScroll.js